const themes = require('../data/themes.json')

const Themes = {}

Themes.themes = themes

module.exports = Themes
